// Credit: https://github.com/steevelefort/siret/blob/master/index.js
function verify(num: string | any, size: number) {
  if (isNaN(num) || num.length !== size) {
    return false;
  }
  let bal = 0;
  let total = 0;
  for (let i = size - 1; i >= 0; i--) {
    const step = (num.charCodeAt(i) - 48) * (bal + 1);
    /*if (step>9) { step -= 9; }
     total += step;*/
    total += (step > 9) ? step - 9 : step;
    bal = 1 - bal;
  }
  return (total % 10 === 0) ? true : false;
}

export const isSIRET = (siret: string) => {
  return verify(String(siret).replace(/ /g, ""), 14);
}

export const isSIREN = (siren: string) => {
  return verify(String(siren).replace(/ /g, ""), 9)
}


// WEBPACK FOOTER //
// ./src/utils/validations/siret.ts